module.exports = __webpack_public_path__ + "static/Koinex-eb6dd1ff26312158f4d4d52c9a227bc3.png";